export default "/_next/static/assets/BebasNeue-Regular_12e3683f9192436a7be8e24657809a1f.ttf";